import { h, FunctionComponent } from 'preact';
import { useEffect } from 'preact/hooks';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Alert } from 'up-ops-web-shared-components';
import * as styles from '~src/styles/domains/common/components/alert.module.scss';
import { trackAlert } from '~src/utils/tracking';
import { AlertNames } from '../enums/common';
import { mcodeSelector } from '../state/commonSelectors';

type AlertProps = {
  type: string;
  i18nKey: string;
  values?: {};
  icon?: boolean;
};

const Alerter: FunctionComponent<AlertProps> = ({
  type,
  i18nKey,
  values,
  icon = false,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const mcode = useSelector(mcodeSelector) as number;

  useEffect(() => {
    dispatch(trackAlert(t(i18nKey), mcode));
  }, []);

  return (
    <Alert
      className={`${styles['alert']} ${type} ${styles[type]}`}
      error={type === AlertNames.ERROR}
      icon={icon || type === AlertNames.ERROR}
      success={type === AlertNames.NOTICE}
      warning={type === AlertNames.WARNING}
      disclaimer={type === AlertNames.DISCLAIMER}
      focusOnRender={true}
    >
      <div data-testid={`alert-${type}`}>
        <Trans i18nKey={i18nKey} values={values} />
      </div>
    </Alert>
  );
};

export default Alerter;
